<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vZjirA/tc-custom/9781609250089.jpg?1718106263054" alt="This image is the cover for the book Change Your Mind and Your Life Will Follow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Change Your Mind and Your Life Will Follow
      </h1>
      <p class="bookDescription body article font2">
        <b>The bestselling author of <i>Each Day a New Beginning</i> offers a practical, easy-to-implement guide to making positive changes—and living the results.</b><br/>  <br/> Thirty years ago, Karen Casey wandered into a support group and learned there was only one thing she could change: <i>herself</i><i>!</i> She found a group of people who had adopted this concept, and she joined them. The resulting transformation was so profound that Casey dedicated herself to teaching others what’s possible when we put our minds to changing our lives.<br/>  <br/><i>Change Your Mind and Your Life Will Follow</i> offers a dozen simple principles to live by. Each principle is explored in its own chapter and includes meditation-style essays to help readers access peaceful, life-changing responses to just about any situation. Finding happiness, peace, and purpose really can be as simple as changing our minds. This little book will show you how.<br/>  <br/><b>“<i>Change Your Mind and Your Life Will Follow</i> tells the truth and tells it well. I recommend it.” —Marianne Williamson</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karen Casey
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Conari Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6988a200